import jsBridge from './jsbridge';
var bridgeName = '_dsbridge';
var bridge = new jsBridge(bridgeName);
/* 与android交互 */
/* function getAndroidBridge() {
  return bridge
}
 */
export function callAndroidHandler(event, params) {
    if (params === void 0) { params = {}; }
    return new Promise(function (resolve) {
        bridge.Android_call(event, params, function (res) {
            if (typeof res === "string" && /{|\[/.test(res)) {
                try {
                    res = JSON.parse(res);
                }
                catch (error) {
                    // console.error(error)
                    throw error;
                }
            }
            resolve(res);
        });
    });
}
export function androidGetCurrentBTYAddress() {
    return callAndroidHandler('getCurrentBTYAddress');
}
export function androidSignRawTransaction(tx) {
    return callAndroidHandler('sign', { createHash: tx });
}
export function androidSignTransactionGroup(tx, exer, withhold) {
    if (withhold === void 0) { withhold = 1; }
    return callAndroidHandler('signTxGroup', { createHash: tx, exer: exer, withhold: withhold });
}
export function androidConfigPrivCache(cachePriv) {
    return callAndroidHandler('configPriv', { cachePriv: cachePriv });
}
//# sourceMappingURL=androidJsBridge.js.map